import "./navbar.scss";
import FullscreenExitOutlinedIcon from "@mui/icons-material/FullscreenExitOutlined";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import { DarkModeContext } from "../../context/darkModeContext";
import { useContext } from "react";

import { Link } from "react-router-dom";

import icon from '../../assets/icon.png';

const Navbar = () => {
  const { darkMode } = useContext(DarkModeContext);

  // Full-screen functionality
  const handleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
    } else if (document.exitFullscreen) {
      document.exitFullscreen();
    }
  };

  return (
    <div className={`navbar ${darkMode ? "dark" : ""}`}>
      <div className="wrapper">
        <div className="search">
        </div>
        <div className="items">
         
         
          <div className="item" onClick={handleFullscreen}>
            <FullscreenExitOutlinedIcon className="icon" />
          </div>
          <Link to="/notification" style={{ textDecoration: "none" }}>
          <div className="item">
            <NotificationsNoneOutlinedIcon className="icon" />
            <div className="counter">1</div>
          </div>
          </Link>
          
          
          <div className="item">
            <img src={icon} alt="" className="avatar" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
